module.exports = __webpack_public_path__ + "img/cmacgm.f001d791.webp";